module.exports = __webpack_public_path__ + "static/media/logo.e693fb59.svg";